import React from 'react';
import { useEffectOnce } from 'react-use';

import {
  type HeaderViewType,
  updateHeader,
} from '@soluto-private/mx-app-header';
import { ErrorPage } from '@soluto-private/mx-asurion-ui-react';

import { logger } from '@service-initiation/shared-clients-osp-logger';
import { useInViewAnalytics } from '@service-initiation/shared-data-access-analytics';

type ErrorBoundaryFallbackProps = {
  backTitle?: string;
  clearError?: () => void;
  error?: Error | Error[];
  homePath?: string;
  href?: string;
  info?: React.ErrorInfo;
  ref?: React.ReactNode;
  title?: string;
  view?: HeaderViewType;
};

export const ErrorBoundaryFallback: React.FC<ErrorBoundaryFallbackProps> = ({
  backTitle,
  error,
  homePath,
  href,
  title,
  view = 'main-view',
}) => {
  const { ref } = useInViewAnalytics('ErrorBoundary');

  useEffectOnce(() => {
    updateHeader({
      backTitle,
      homePath,
      title,
      view,
    });
    if (error) {
      if (Array.isArray(error)) {
        for (const err of error) {
          logger.error(err);
        }
      } else {
        logger.error(error);
      }
    }
  });

  return (
    <div ref={ref}>
      <ErrorPage
        actionLabel="Try Again"
        link={{
          href: href || window.location.href,
        }}
        subtitle="Please try again."
        title="We seem to be having some difficulties."
      />
    </div>
  );
};
export default ErrorBoundaryFallback;
